import React from 'react'
import { Tile, TileImage } from '@mc/design-system'
import { Trans } from '@mc/i18n'
import Image from 'components/LegacyImage'
import { type OutcomeKeyLearnings } from 'libs/server/api/outcomes'
import { CM_OUTCOMES_I18N_NAMESPACE } from '../../i18n'
import { useShowKeyLearnings } from './useShowKeyLearnings'
import styles from './OutcomeTiles.module.scss'

const OutcomeTile = React.memo(
  ({
    outcome,
    position,
  }: {
    outcome: OutcomeKeyLearnings
    position: number
  }) => {
    const { lessonVideoThumbUrl } = outcome
    const { Content, Overlay } = useShowKeyLearnings({ outcome, position })

    return (
      <Tile
        className={`mc-corners--md mc-overflow--hidden ${styles.tile}`}
        aspectRatio='16x9'
      >
        <Overlay />

        {lessonVideoThumbUrl && (
          <TileImage
            image={
              <Image
                src={lessonVideoThumbUrl}
                alt=''
                layout='fill'
                objectFit='cover'
              />
            }
          />
        )}

        <Content />
      </Tile>
    )
  },
)

OutcomeTile.displayName = 'OutcomeTile'

export const OutcomeTilesMobile = ({
  outcomesKeyLearnings,
}: {
  outcomesKeyLearnings: OutcomeKeyLearnings[]
}) => (
  <div className='d-flex flex-column flex-gap-3'>
    <h2 className='mc-text-h2 mc-mb-5'>
      <Trans ns={CM_OUTCOMES_I18N_NAMESPACE} i18nKey='outcomesOnCM.title' />
    </h2>
    {outcomesKeyLearnings.map((outcome: OutcomeKeyLearnings, index: number) => (
      <div key={outcome.slug}>
        <OutcomeTile outcome={outcome} position={index} />
      </div>
    ))}
  </div>
)
